import PropTypes from 'prop-types';
import get from 'lodash/get';

import { getBgColor } from '~/app/lib/get-bg-color';
import {
  backgroundColorPicker,
  stringInputSpec,
} from '~/app/lib/editing-configs';

const customBackgroundPicker = (baseName, label) => ({
  ...backgroundColorPicker,
  fieldName: `${baseName}.backgroundColor`,
  fieldLabel: label || 'Background color',
  items: backgroundColorPicker.items.concat({
    value: 'HEXCOLOR',
    label: 'Hexcolor',
  }),
});

const BackgroundColor = ({ bgOptions, children }) => {
  const color = getBgColor(bgOptions);
  return children(color);
};

BackgroundColor.propTypes = {
  bgOptions: PropTypes.shape({
    backgroundColor: PropTypes.string,
    hexColor: PropTypes.string,
  }),
  children: PropTypes.func.isRequired,
};

BackgroundColor.getEditingConfig = (componentDocument, fieldName, label) => {
  const baseName = fieldName || 'bgOptions';
  const optionalSelect =
    get(componentDocument, `props.${baseName}.backgroundColor`, '') ===
    'HEXCOLOR'
      ? [
          stringInputSpec(
            `${baseName}.hexColor`,
            'Background hex color override'
          ),
        ]
      : [];
  return [customBackgroundPicker(baseName, label), ...optionalSelect];
};

BackgroundColor.defaultProps = {
  bgOptions: {
    hexColor: '',
  },
};

export default BackgroundColor;
